import { reportTypes } from "../actionTypes";

export const addUnitReport = (reportId, data) => {
    return {
        type: reportTypes.ADD_UNIT,
        payload: {
            reportId, // Unique identifier for the report
            data
        }
    };
};
export const updateCallCount = (reportId)=>{
    return {
        type: reportTypes.UPDATE_CALL_COUNT,
        payload: {
            reportId, // Unique identifier for the report
        }
    };
}

// The names the Reports page uses. Same actions: addReport merges `partial`
// into the existing entry, incrementCall bumps its currentCall by one.
export const addReport = (reportId, partial) => addUnitReport(reportId, partial);
export const incrementCall = (reportId) => updateCallCount(reportId);
